import PakUki from '../../../assets/img/tentang-kami/pak-uki.png'
import PakAzhar from '../../../assets/img/tentang-kami/azhar.png'
// import BuRiesa from '../../assets/img/tentangkami/riesanty.png'
import PakIr from '../../../assets/img/tentang-kami/iriantogunawan.png'
import PakEdwin from '../../../assets/img/tentang-kami/pak-edwin.png'

function DireksiKomisaris() {
    return (
        <>
            <article className="structure float-left">
                <div style={{ backgroundColor: '#ffffff'}} className="general-container ui-g">
                    <div className="space-direksi ui-g-6 title">
                        <header id="myAnchor" style={{ marginTop: '0', marginBottom: '4em' }}>
                            <h2 style={{ marginLeft: '0' }}> Direksi &amp; Komisaris</h2>
                            <span className="blue-line" />
                        </header>
                    </div>
                    <p>
                        <div id="direksi" className="product-wrapper-direksi active">
                            <div className="ui-g product-item">
                                <div className="ui-g-12 ui-md-6 ui-lg-3 card komisaris">
                                    <a className="clickable anchorLink" href="#myAnchor">
                                        <p className="tag-card">Komisaris</p>
                                        <img className='img-product' src={PakUki} alt='Komisaris' />
                                        <h4>Adimukyo Mardjikoen</h4>
                                        <p className="title">Komisaris</p>
                                        <span className="blue-line" />
                                        <p className="desc">25+ Tahun pengalaman dalam Bank Sentral Indonesia dan Industri Perbankan.</p>
                                    </a>
                                </div>
                            </div>

                            <div className="ui-g product-item">

                                <div className="ui-g-12 ui-md-6 ui-lg-4 card">
                                    <a className="clickable anchorLink" href="#myAnchor">
                                        <p className="tag-card direksi">Direksi</p>
                                        <img className='img-product' src={PakAzhar} alt='Komisaris' />
                                        <h4>Azhar Abdul Wahab</h4>
                                        <p className="title">Direktur Utama</p>
                                        <span className="blue-line" />
                                        <p className="desc">25+ Tahun pengalaman dalam Investment Banking dan Perbankan Komersial.</p>
                                    </a>
                                </div>

                                {/*<div className="ui-g-12 ui-md-6 ui-lg-3 card">*/}
                                {/*    <a className="clickable anchorLink" href="#myAnchor">*/}
                                {/*        <p className="tag-card direksi">Direksi</p>*/}
                                {/*        <img className='img-product' src={BuRiesa} alt='Komisaris' />*/}
                                {/*        <h4>Monica Riesanty Wahyudi</h4>*/}
                                {/*        <p className="title">Direktur Operasi &amp; Hubungan Pendana</p>*/}
                                {/*        <span className="blue-line" />*/}
                                {/*        <p className="desc">25+ Tahun pengalaman dalam Retail, Wealth Management, Commercial Banking dan E-Banking.</p>*/}
                                {/*    </a>*/}
                                {/*</div>*/}

                                <div className="ui-g-12 ui-md-6 ui-lg-4 card">
                                    <a className="clickable anchorLink" href="#myAnchor">
                                        <p className="tag-card direksi">Direksi</p>
                                        <img className='img-product' src={PakIr} alt='Komisaris' />
                                        <h4>Irianto Gunawan</h4>
                                        <p className="title">Direktur</p>
                                        <span className="blue-line" />
                                        <p className="desc">25+ Tahun pengalaman di Retail &amp; Commercial Business</p>
                                    </a>
                                </div>

                                <div className="ui-g-12 ui-md-6 ui-lg-4 card">
                                    <a className="clickable anchorLink" href="#myAnchor">
                                        <p className="tag-card direksi">Direksi</p>
                                        <img className='img-product' src={PakEdwin} alt='Komisaris' />
                                        <h4>Edwin Tanu Teintang</h4>
                                        <p className="title">Direktur</p>
                                        <span className="blue-line" />
                                        <p className="desc">25+ Tahun pengalaman dalam industri Perbankan dan Pasar Modal.</p>
                                    </a>
                                </div>

                            </div>
                        </div>
                    </p>
                </div>
            </article>
        </>
    );
}

export default DireksiKomisaris;
